document.addEventListener('DOMContentLoaded', () => {
  const summary = document.querySelector('[data-emi-summary]');
  if (!summary) return;

  // Same day of month, clamped to the month's last day (31 Jan -> 28 Feb), as on the live theme.
  const addMonths = (date, months) => {
    const due = new Date(date.getFullYear(), date.getMonth() + months, 1);
    const lastDay = new Date(due.getFullYear(), due.getMonth() + 1, 0).getDate();
    due.setDate(Math.min(date.getDate(), lastDay));
    return due;
  };

  const today = new Date();
  for (const dueEl of summary.querySelectorAll('[data-emi-due]')) {
    const due = addMonths(today, Number(dueEl.dataset.emiDue));
    dueEl.textContent = due.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  }

  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const { productId } = summary.dataset;
  const variantEls = [...summary.querySelectorAll('[data-emi-variant]')];

  subscribe(PUB_SUB_EVENTS.variantChange, ({ productId: changedId, variant }) => {
    if (changedId !== productId || !variant) return;

    for (const el of variantEls) {
      el.hidden = el.dataset.emiVariant !== String(variant.id);
    }
  });
});
